module.exports = __webpack_public_path__ + "images/a-kurdyukov_big-fa91b7.jpg";